import { useEffect, useState } from "react";
import { Info, Moon, AlertTriangle } from "lucide-react";
import { api, eur, todayRome } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Field } from "@/components/common";

export const SlotPicker = ({ date, onDate, notturno = false, onNotturno, admin = false }) => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!date) return setInfo(null);
    api.get("/public/availability", { params: { date, notturno } }).then((r) => setInfo(r.data)).catch(() => setInfo(null));
  }, [date, notturno]);

  return (
    <div className="space-y-4">
      <Field label="Giorno del ritiro">
        <Input type="date" data-testid="slot-date-input" min={admin ? undefined : todayRome()} value={date}
          onChange={(e) => onDate(e.target.value)} className="bg-white" />
      </Field>
      <label className="flex items-start gap-3 rounded-lg border border-[#E2DDD5] bg-white p-3 cursor-pointer">
        <Checkbox data-testid="booking-notturno" checked={notturno} onCheckedChange={(v) => onNotturno?.(!!v)} className="mt-0.5" />
        <span className="text-sm text-[#1C2A33]"><Moon className="inline h-4 w-4 mr-1 text-[#B8860B]" />Ritiro notturno (dopo le 18:00)</span>
      </label>
      {info && info.maggiorazione > 0 && (
        <div className="flex gap-2 rounded-lg bg-amber-50 border border-amber-200 p-3 text-sm text-amber-900" data-testid="booking-surcharge">
          <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" />
          <p>{info.festivo ? "Giorno festivo/domenica" : "Ritiro notturno"}: maggiorazione di <strong>{eur(info.maggiorazione)} + IVA</strong> ({eur(info.maggiorazione_iva)} IVA inclusa).</p>
        </div>
      )}
      <div className="flex gap-2 rounded-lg bg-[#F4E8C1]/50 p-3 text-xs text-[#5C4A12]">
        <Info className="h-4 w-4 shrink-0 mt-0.5" />
        <p>Ritiri tutti i giorni. Indica solo il giorno: sarà l'agenzia a contattarti per concordare l'orario. Domeniche, festivi e ritiri notturni prevedono una maggiorazione di € 150 + IVA.</p>
      </div>
    </div>
  );
};
